<header class="mt-3">
        <h3>
          Legendas
        </h3>
</header>

<main class="card-legenda row">
          <table class="col-sm-12 col-md-12 col-lg-6 col-xl-6 letter-content-padrao">
            <tr>
              <td>
                <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/apalc.png">
              </td>
              <td>Padrão Nacional de Qualidade</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/adicq.png">
              </td>
              <td>
                <p class="descricao-legenda">Padrão Nacional de Qualidade</p>
              </td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/aona.png">
              </td>
              <td>Padrão Nacional de Qualidade</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/acba.png">
              </td>
              <td>Padrão Internacional de Qualidade</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda" src="../../../../assets/img/png/rede-credenciada/aiqg.png">
              </td>
              <td>Padrão Internacional de Qualidade</td>
            </tr>
            <tr class="not-mobile-tablet">
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/n.png">
              </td>
              <td>Comunicação de eventos adversos</td>
            </tr>
            <tr class="not-mobile-tablet">
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/p.png">
              </td>
              <td>Profissional com especialização</td>
            </tr>
          </table>

          <table class="col-sm-12 col-md-12 col-lg-6 col-xl-6 letter-content">
            <tr>
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/n.png">
              </td>
              <td>Comunicação de eventos adversos</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/p.png">
              </td>
              <td>Profissional com especialização</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/r.png">
              </td>
              <td>Profissional com residência</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/e.png">
              </td>
              <td>Título de especialista</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/q.png">
              </td>
              <td>Qualidade monitorada</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/g.png">
              </td>
              <td>Certificações de Entidades Gestoras de Outros Programas de Qualidade</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/i.png">
              </td>
              <td>Certificação ISO 9001</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/d.png">
              </td>
              <td>Profissional com Doutorado ou Pós-Doutorado</td>
            </tr>
            <tr>
              <td>
                <img class="imagem-legenda-letter" src="../../../../assets/img/png/rede-credenciada/m.png">
              </td>
              <td>Mestrado em saúde reconhecido pelo MEC</td>
            </tr>
          </table>
</main>